export const pageManifest = [
  {
    "id": "home",
    "path": "/",
    "title": "Home",
    "type": "home",
    "service": ""
  },
  {
    "id": "auto",
    "path": "/autoglass.html",
    "title": "Auto Glass",
    "type": "landing",
    "service": "Auto Glass"
  },
  {
    "id": "windshield",
    "path": "/windshieldreplacement.html",
    "title": "Windshield Replacement",
    "type": "specialty",
    "service": "Auto Glass"
  },
  {
    "id": "chip",
    "path": "/Windshield-Chip-Repair",
    "title": "Windshield Chip Repair",
    "type": "specialty",
    "service": "Auto Glass"
  },
  {
    "id": "adas",
    "path": "/ADAS-Calibration-On-Site",
    "title": "ADAS Calibration",
    "type": "specialty",
    "service": "Auto Glass"
  },
  {
    "id": "emergency",
    "path": "/emergency-auto-glass-repair.html",
    "title": "Emergency Auto Glass",
    "type": "landing",
    "service": "Auto Glass"
  },
  {
    "id": "residential",
    "path": "/residentialglass.html",
    "title": "Residential Glass",
    "type": "landing",
    "service": "Residential Glass"
  },
  {
    "id": "windows",
    "path": "/replacementwindows.html",
    "title": "Glass vs Replacement Windows",
    "type": "specialty",
    "service": "Residential Glass"
  },
  {
    "id": "window-glass",
    "path": "/windowglass.html",
    "title": "Window Glass",
    "type": "specialty",
    "service": "Residential Glass"
  },
  {
    "id": "mirrors",
    "path": "/customglassmirrors.html",
    "title": "Custom Mirrors",
    "type": "specialty",
    "service": "Residential Glass"
  },
  {
    "id": "deck",
    "path": "/deckglass.html",
    "title": "Glass Deck Railing",
    "type": "specialty",
    "service": "Residential Glass"
  },
  {
    "id": "shower",
    "path": "/euroglasshowerdoors.html",
    "title": "Glass Shower Doors",
    "type": "landing",
    "service": "Glass Shower Doors"
  },
  {
    "id": "commercial",
    "path": "/commercialglass.html",
    "title": "Commercial Glass",
    "type": "landing",
    "service": "Commercial Glass"
  },
  {
    "id": "employment",
    "path": "/application-for-employment.html",
    "title": "Employment",
    "type": "employment",
    "service": ""
  },
  {
    "id": "terms",
    "path": "/terms-of-service.html",
    "title": "Terms Of Service",
    "type": "legal",
    "service": ""
  },
  {
    "id": "contact",
    "path": "/contact-kosins-glass.html",
    "title": "Contact Us",
    "type": "contact",
    "service": ""
  },
  {
    "id": "resources",
    "path": "/glass-resources-expert-guides",
    "title": "Glass Resources & Expert Guides",
    "type": "resources",
    "service": ""
  },
  {
    "id": "privacy",
    "path": "/privacy-policy.html",
    "title": "Privacy Policy",
    "type": "legal",
    "service": ""
  },
  {
    "id": "ann-arbor",
    "path": "/glassannarbormichigan.html",
    "title": "Ann Arbor",
    "type": "area",
    "service": ""
  },
  {
    "id": "brighton",
    "path": "/glassrepairbrighton.html",
    "title": "Brighton",
    "type": "area",
    "service": ""
  },
  {
    "id": "commerce",
    "path": "/glasscommercemichigan.html",
    "title": "Commerce",
    "type": "area",
    "service": ""
  },
  {
    "id": "fenton",
    "path": "/glassfentonmichigan.html",
    "title": "Fenton",
    "type": "area",
    "service": ""
  },
  {
    "id": "fowlerville",
    "path": "/glassfowlervillemichigan.html",
    "title": "Fowlerville",
    "type": "area",
    "service": ""
  },
  {
    "id": "highland",
    "path": "/glasshighlandmichigan.html",
    "title": "Highland",
    "type": "area",
    "service": ""
  },
  {
    "id": "howell",
    "path": "/glassrepairhowellmichigan.html",
    "title": "Howell",
    "type": "area",
    "service": ""
  },
  {
    "id": "lansing",
    "path": "/glassrepairlansingmichigan.html",
    "title": "Lansing",
    "type": "area",
    "service": ""
  },
  {
    "id": "northville",
    "path": "/glassnorthvillemichigan.html",
    "title": "Northville",
    "type": "area",
    "service": ""
  },
  {
    "id": "novi",
    "path": "/glassnovimichigan.html",
    "title": "Novi",
    "type": "area",
    "service": ""
  },
  {
    "id": "pinckney",
    "path": "/glasspinckneymichigan.html",
    "title": "Pinckney",
    "type": "area",
    "service": ""
  },
  {
    "id": "webberville",
    "path": "/glasswebbervillemichigan.html",
    "title": "Webberville",
    "type": "area",
    "service": ""
  },
  {
    "id": "williamston",
    "path": "/glasswilliamstonmichigan.html",
    "title": "Williamston",
    "type": "area",
    "service": ""
  }
] as const
